module.exports = __webpack_public_path__ + "static/img/pic_dianzhen.164469b.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/select_cust_type/01person/pic_dianzhen.png
// module id = 857
// module chunks = 2